module.exports = __webpack_public_path__ + "static/media/2019_IMG_9526.1b81603e.jpg";